import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';
import { Provider } from 'mobx-react';
import store from './store';
import { setOption } from './utils';
import './common.less';
import './com/mescroll.min.css';

// 设置默认请求
let url: string = '';
let appId: string = '';
if (window.location.href.indexOf('https://h5.gjyymall.com') !== -1) {
    url = 'https://h5.gjyymall.com/api/pub/'; // 测试环境
    appId = 'wxeb12e11c1c5e1020';
} else {
    url = 'https://h5.gjyymall.com/api/pub/'; // 正式环境
    appId = 'wxeb12e11c1c5e1020';
}
setOption({
    url: url,
    appUrl: url + 'user/weixin/v1/login',
    appId: appId,
    defaultMethod: 'POST',
});
// store.user.setPartnerId();

if (window.location.href.indexOf('?') === -1) {
    let urlArr: any[] = location.href.split('#');
    window.history.replaceState(null, document.title, `${urlArr[0]}?#${urlArr[1] ? urlArr[1] : '!/'}`);
}

ReactDOM.render(
    <Provider {...store}>
        <App />
    </Provider>,
    document.getElementById('root') as HTMLElement
);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/indexbuild.tsx